var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1436 5.4948C11.1436 5.0633 11.1086 4.74842 11.0328 4.42188H6.10547V6.36946H8.9977C8.93941 6.85346 8.62453 7.58236 7.92478 8.07215L7.91497 8.13736L9.4729 9.34427L9.58084 9.35504C10.5721 8.43954 11.1436 7.09253 11.1436 5.4948Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10526 10.6261C7.52221 10.6261 8.71176 10.1596 9.58063 9.35492L7.92457 8.07203C7.48141 8.38109 6.88662 8.59684 6.10526 8.59684C4.71745 8.59684 3.53957 7.68138 3.11968 6.41602L3.05814 6.42124L1.43818 7.67494L1.41699 7.73384C2.28 9.44818 4.05267 10.6261 6.10526 10.6261Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11989 6.41734C3.0091 6.0908 2.94498 5.7409 2.94498 5.37939C2.94498 5.01783 3.0091 4.66798 3.11406 4.34143L3.11113 4.27189L1.47087 2.99805L1.4172 3.02357C1.06151 3.73498 0.857422 4.53387 0.857422 5.37939C0.857422 6.2249 1.06151 7.02375 1.4172 7.73516L3.11989 6.41734Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10526 2.16009C7.09071 2.16009 7.75545 2.58576 8.13449 2.94149L9.61561 1.49535C8.70597 0.649835 7.52221 0.130859 6.10526 0.130859C4.05267 0.130859 2.28 1.30875 1.41699 3.02309L3.11385 4.34095C3.53957 3.07559 4.71745 2.16009 6.10526 2.16009Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.9d38ad1d587ccada1a084059e98b1bb2.svg";
export { ForwardRef as ReactComponent };